import React from 'react';

import classes from './BuildControls.module.css';

import BuildControl from './BuildControl/BuildControl';

const BuildControls = (props) => {
	return (
		<div className={classes.BuildControls}>
			<p className={classes.Price}>Total Price: {props.price.toFixed(2)}</p>
			{props.controls.map((control) =>
				control.type !== 'bread-top' && control.type !== 'bread-bottom' ? (
					<BuildControl
						key={control.type}
						label={control.type}
						increase={props.addIngredient.bind(null, control.type)}
						decrease={props.removeIngredient.bind(null, control.type)}
						disabled={props.disabledInfo[control.type]}
					/>
				) : null
			)}
			<button
				className={classes.OrderButton}
				disabled={!props.purchaseable}
				onClick={props.orderNow}
			>
				{props.isAuth ? 'Order Now!' : 'SignIn To Order Now!'}
			</button>
		</div>
	);
};

export default BuildControls;
